import type { RouteRecordRaw } from 'vue-router';
import { APPROVAL_ROUTE_NAMES, APPROVAL_ROUTE_PATHS } from '@/shared/common/constants/approvalRoutes.constant';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const ListApproval = () => import('@/modules/transactionApproval/pages/ListApproval/index.vue');
const Approve = () => import('@/modules/transactionApproval/pages/Approve/index.vue');
const MultiApprovalConfirm = () =>
  import('@/modules/transactionApproval/pages/MultiApprovalConfirm/index.vue');

export const transactionApprovalRoutes: Array<RouteRecordRaw> = [
  {
    path: APPROVAL_ROUTE_PATHS[APPROVAL_ROUTE_NAMES.LIST],
    component: MainLayout,
    children: [
      {
        path: '',
        name: APPROVAL_ROUTE_NAMES.LIST,
        component: ListApproval,
        meta: {
          requiresAuth: true,
          title: 'Aprobaciones',
          accessRol: {
            section: 'PENDING_APPROVALS',
            actions: ['VIEW'],
          },
        },
      },
    ],
  },
  {
    path: APPROVAL_ROUTE_PATHS[APPROVAL_ROUTE_NAMES.APPROVE],
    name: APPROVAL_ROUTE_NAMES.APPROVE,
    redirect: {
      name: APPROVAL_ROUTE_NAMES.APPROVE_TRANSACTION,
    },
    component: EmptyLayout,
    children: [
      {
        path: APPROVAL_ROUTE_PATHS[APPROVAL_ROUTE_NAMES.APPROVE_TRANSACTION],
        name: APPROVAL_ROUTE_NAMES.APPROVE_TRANSACTION,
        component: Approve,
        meta: {
          requiresAuth: true,
          title: 'Aprobar',
          accessRol: {
            section: 'PENDING_APPROVALS',
            actions: ['APPROVE'],
          },
        },
      },
    ],
  },
  {
    path: APPROVAL_ROUTE_PATHS[APPROVAL_ROUTE_NAMES.MULTI_APPROVAL_SUMMARY],
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: APPROVAL_ROUTE_NAMES.MULTI_APPROVAL_SUMMARY,
        component: MultiApprovalConfirm,
        meta: {
          requiresAuth: true,
          title: 'Aprobar transacciones',
          // El resumen solo existe dentro de la multi-aprobación: con el flag
          // apagado no hay forma de llegar acá desde el listado.
          flag: 'feature_multi_approvals',
          accessRol: {
            section: 'PENDING_APPROVALS',
            actions: ['APPROVE'],
          },
        },
      },
    ],
  },
];
